import { fetchAnalysisAuditById, patchAnalysisReview } from '../state/actions/AnalysisActions';

import PropTypes from 'prop-types';
import React from 'react';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class AnalysisPriority extends React.PureComponent {
    static propTypes = {
        analysisId: PropTypes.string,
        priority: PropTypes.number,
        patchAnalysisReview: PropTypes.func,
        fetchAnalysisAuditById: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.priority = React.createRef();
    }

    clearPriority = () => {
        this.priority.current.value = '';
    };

    savePriority = async () => {
        const { patchAnalysisReview, fetchAnalysisAuditById } = this.props;

        const { analysisId } = this.props;
        const { value: analysisPriority } = this.priority.current;

        await patchAnalysisReview({ analysisId, analysisPriority }).catch(error => {
            Swal({
                title: 'Oops...',
                text: error.message,
                type: 'error',
            });
            throw error;
        });

        fetchAnalysisAuditById(analysisId);
    };

    render() {
        const { priority } = this.props;

        return (
            <div>
                <strong className="pr-1">Analysis Priority:</strong>
                <input
                    className="mr-2"
                    ref={this.priority}
                    type="number"
                    min="0"
                    max="100"
                    defaultValue={priority}
                />
                <button className="btn btn-secondary" onClick={this.clearPriority}>
                    Remove Priority
                </button>
                <br />
                <small>*Lower is higher priority</small>
                <br />
                <div className="form-group row d-flex justify-content-end">
                    <button className="btn btn-primary" onClick={this.savePriority}>
                        Save Priority
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => state.analysis;

const mapDispatchToProps = dispatch =>
    bindActionCreators({ patchAnalysisReview, fetchAnalysisAuditById }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AnalysisPriority);
